const doc = [({"en":({"js":({"layout":({"top_nav":({"notifications_modal":({"you_have_no_unread_notifications":"You have no unread notifications."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;